module.exports = __webpack_public_path__ + "static/media/Snoring.cfad60a7.png";